export const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  
  export const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };
  

export const isMoreThanThreeMonths = (fromDate, toDate) => {
  if (!fromDate || !toDate) return false;

  const start = new Date(fromDate);
  const end = new Date(toDate);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return false;

  if (end < start) return false;

  const maxAllowed = new Date(start.getTime());
  maxAllowed.setMonth(maxAllowed.getMonth() + 3);

  return end.getTime() <= maxAllowed.getTime();
};

export const isMoreThanThirtyDays = (fromDate, toDate) => {
  if (!fromDate || !toDate) return false;

  const start = new Date(fromDate);
  const end = new Date(toDate);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return false;

  if (end < start) return false;

  const diffInMs = end.getTime() - start.getTime();
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  return diffInDays <= 30;
};

// Helper function to format month to uppercase "DEC-25" format
export const formatMonth = (monthString) => {
  if (!monthString) return '-----';
  return monthString.toUpperCase();
};

 // Helper function to check if a month is the current month
export const isCurrentMonth = (monthString) => {
  if (!monthString) return false;

  const now = new Date();
  const currentMonth = now.toLocaleString('en-US', { month: 'short' }).toUpperCase();
  const currentYear = now.getFullYear().toString().slice(-2);
  const currentMonthYear = `${currentMonth}-${currentYear}`;

  return monthString.toUpperCase() === currentMonthYear;
};

